import React, { Fragment, useEffect, useState } from "react";
import { HISTORY_PROPS } from "./interface";
import { HistoryCard, HistoryRow } from "./GambleComponentsStyled";

import { useCard } from "@orbital/games-frontend-library";
export default function GambleHistory({
  colors,
  gambleHistory,
  state,
}: HISTORY_PROPS) {
  const { handleCardSuit, handleCardColor } = useCard();
  const [addInHistory, setAddInHistory] = useState<boolean>(false);
  useEffect(() => {
    let timeout: any;
    setAddInHistory(true);
    timeout = setTimeout(() => {
      setAddInHistory(false);
    }, 550);
    return function cleanUp() {
      clearTimeout(timeout);
    };
  }, [gambleHistory]);

  return (
    <Fragment>
      <h3> History </h3>
      <HistoryRow>
        {gambleHistory.map((suit: string, id: number) => (
          <HistoryCard
            key={id}
            background={handleCardColor(
              suit,
              colors.secondaryText,
              colors.secondaryBackground
            )}
            addNewItem={addInHistory && state !== 7}
            removeOldItem={
              addInHistory && state !== 7 && gambleHistory.length > 7
            }
            className="items"
          >
            <div className="item">{handleCardSuit(suit)}</div>
          </HistoryCard>
        ))}
      </HistoryRow>
    </Fragment>
  );
}
